// import React, { Component } from 'react';
// import Zoom from 'react-reveal/Zoom';
// import { Link } from 'react-router-dom';
// import AppUrl from '../../restApi/AppUrl';
// import IRestClient from '../../restApi/IRestClient';
// import ReactHtmlParser from 'react-html-parser';
// import Wentwrong from '../Wentwrong/Wentwrong';
// import Loading from '../Loading/Loading';


// class Allprojects extends Component{
//     constructor(){
//         super();
//         this.state={ 
//             myData:[] ,
//             error:false,
//             loading:true 
//         }
//    }

//     componentDidMount(){          
//         IRestClient.GetRequest(AppUrl.Recentprojectsall).then(result=>{
//             if(result == null){
//                 this.setState({error:true,loading:false})
//            }else{
//              this.setState({myData:result,loading:false});
//               }//end else
//             }).catch(error=>{
//                 this.setState({error:true})
//            }) 
//    }
//     render(){
//         if(this.state.loading == true){
//             return <Loading />
//        }
//        else if(this.state.loading == false && this.state.error == false){
//         const projects = this.state.myData;
//         const myproject = projects.map(project => {
//             return <div class="col-lg-4">
//             <div class="blog-item">
//                 <div class="blog-img">
//                     <Zoom top>
//                     <Link className='allLinks' to={'/projectdetails/'+project.id+"/"+project.project_title}>

//                     <img src={project.project_image} alt="Image"/>
//                     </Link>
//                     </Zoom>
//                 </div>
//                 <div class="blog-text">
//                 <Zoom top>
//                     <h3>
//                     <Link className='allLinks' to={'/projectdetails/'+project.id+"/"+project.project_title}>

//                             {project.project_title}
//                             </Link>
//                     </h3>
//                     <p>
//                     { ReactHtmlParser(project.project_description.substring(0, 150)) }....
//                     {/* <p>{ ReactHtmlParser(project.project_description.substring(0, 150)) }......</p> */}

//                     </p>
//                 </Zoom>

//                 </div>
//                 <div class="blog-meta">
//                     <p><i class="fa fa-calendar-alt"></i><a href="" style={{ cursor:'none' }}>{project.date}</a></p>
//                     <p><i class="fa fa-map-marker-alt"></i><a href="" style={{ cursor:'none' }}>{project.project_location}</a></p>
//                 </div>
//             </div>
//         </div>
//         })

//         return(
//             <div>
//                   <div class="blog">
//                       <div class="container">
//                             <div class="section-header text-center">
//                                 {/* <p>Our Projects</p> */}
//                                 <h1 className='allTitle'>All projects </h1>
//                                 <div className='alltitleLine'></div>
//                             </div>
//                             <div class="row">
//                                 {myproject}
//                             </div>

//                      </div>

//               </div>
//             </div>
//         );
//         }//end if

//         else if(this.state.error == true){
//             return <Wentwrong />
//           } // end if for error 
//     }
// }
// export default Allprojects
import React, { Component } from 'react';
import Zoom from 'react-reveal/Zoom';
import { Link } from 'react-router-dom';
import AppUrl from '../../restApi/AppUrl';
import IRestClient from '../../restApi/IRestClient';
import ReactHtmlParser from 'react-html-parser';
import Wentwrong from '../Wentwrong/Wentwrong';
import { FaCalendarAlt, FaMapMarkerAlt, FaArrowRight } from 'react-icons/fa';

class Allprojects extends Component {
    constructor() {
        super();
        this.state = {
            myData: [],
            error: false,
            loading: true,
            isHovered: null
        };
    }

    componentDidMount() {
        IRestClient.GetRequest(AppUrl.Recentprojectsall).then(result => {
            if (result == null) {
                this.setState({ error: true, loading: false });
            } else {
                this.setState({ myData: result, loading: false });
            }
        }).catch(error => {
            this.setState({ error: true });
        });
    }

    handleHover = (index) => {
        this.setState({ isHovered: index });
    };

    handleLeave = () => {
        this.setState({ isHovered: null });
    };

    render() {
        if (this.state.loading == true) {
            return (
                <section className="modern-projects">
                    <div className="container">
                        <div className="section-header">
                            <div className="animate-pulse bg-gray-200" style={{ borderRadius: '20px', height: '20px', width: '120px', margin: '0 auto 12px' }} />
                            <div className="animate-pulse bg-gray-200" style={{ borderRadius: '8px', height: '42px', width: '200px', margin: '0 auto 30px' }} />
                            <div className="animate-pulse bg-gray-200" style={{ borderRadius: '4px', height: '16px', width: '320px', margin: '0 auto' }} />
                        </div>
                        <div className="projects-container">
                            {[1, 2, 3, 4, 5, 6].map(i => (
                                <div key={i} style={{ background: '#fff', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 10px 30px rgba(0,0,0,0.05)' }}>
                                    <div className="animate-pulse bg-gray-200" style={{ aspectRatio: '3/2', width: '100%' }} />
                                    <div style={{ padding: '25px' }}>
                                        <div className="animate-pulse bg-gray-200" style={{ borderRadius: '4px', height: '14px', width: '60%', marginBottom: '15px' }} />
                                        <div className="animate-pulse bg-gray-200" style={{ borderRadius: '4px', height: '22px', width: '85%', marginBottom: '8px' }} />
                                        <div className="animate-pulse bg-gray-200" style={{ borderRadius: '4px', height: '22px', width: '65%', marginBottom: '15px' }} />
                                        <div className="animate-pulse bg-gray-200" style={{ borderRadius: '4px', height: '14px', width: '100%', marginBottom: '6px' }} />
                                        <div className="animate-pulse bg-gray-200" style={{ borderRadius: '4px', height: '14px', width: '88%', marginBottom: '20px' }} />
                                        <div className="animate-pulse bg-gray-200" style={{ borderRadius: '4px', height: '14px', width: '100px' }} />
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>
            );
        }
        else if (this.state.loading == false && this.state.error == false) {
            const { myData, isHovered } = this.state;

            return (
                <section className="modern-projects">
                    <div className="container">
                        <div className="section-header">
                            <span className="section-subtitle">Our Work</span>
                            <h2 className="section-title">All Projects</h2>
                            <div className="section-divider"></div>
                            <p className="section-description">
                                Explore all of our humanitarian projects and initiatives
                            </p>
                        </div>

                        <div className="projects-container">
                            {myData.map((project, index) => (
                                <Zoom key={project.id} top>
                                    <div
                                        className={`project-card ${isHovered === index ? 'hovered' : ''}`}
                                        onMouseEnter={() => this.handleHover(index)}
                                        onMouseLeave={this.handleLeave}
                                    >
                                        <div className="card-image">
                                            <Link to={`/projectdetails/${project.id}/${project.project_title}`}>
                                                <img
                                                    src={project.project_image}
                                                    alt={project.project_title}
                                                    className="project-image"
                                                    loading="lazy"
                                                    decoding="async"
                                                    onError={e => { e.currentTarget.src = '/default-project-image.jpg'; }}
                                                />
                                            </Link>
                                            <div className="image-overlay"></div>
                                        </div>

                                        <div className="card-content">
                                            <div className="project-meta">
                                                <span className="meta-item">
                                                    <FaCalendarAlt className="meta-icon" />
                                                    {project.date}
                                                </span>
                                                <span className="meta-item">
                                                    <FaMapMarkerAlt className="meta-icon" />
                                                    {project.project_location}
                                                </span>
                                            </div>

                                            <h3 className="project-title">
                                                <Link to={`/projectdetails/${project.id}/${project.project_title}`}>
                                                    {project.project_title}
                                                </Link>
                                            </h3>

                                            <p className="project-excerpt">
                                                  {ReactHtmlParser((project.project_description || '').substring(0, 120) + '...')}

                                            </p>

                                            <Link
                                                to={`/projectdetails/${project.id}/${project.project_title}`}
                                                className="project-link"
                                            >
                                                Read More <FaArrowRight className="link-arrow" />
                                            </Link>
                                        </div>
                                    </div>
                                </Zoom>
                            ))}
                        </div>
                    </div>
                </section>
            );
        }
        else if (this.state.error == true) {
            return <Wentwrong />;
        }
    }
}

export default Allprojects;